import type { TimeSlot } from '@/types';

export type TimeSlotTarget = TimeSlot['target'][number];

// `timeSlotTargets` in the Drizzle schema — the order the checkbox list renders in.
export const TIME_SLOT_TARGETS: readonly TimeSlotTarget[] = [
  'hackers',
  'mentors',
  'sponsors',
  'judges',
];

export const COLOR_PRESETS = [
  { name: 'Primary Yellow', value: '#e1ff00' },
  { name: 'Primary Yellow (Transparent)', value: '#e1ff0033' },
  { name: 'Red', value: '#ea1414' },
  { name: 'Gray', value: '#d1d5d1' },
  { name: 'Dark Gray', value: '#333333' },
  { name: 'Black', value: '#000000' },
];

// What `<Input type="datetime-local">` reads and writes: the instant rendered as the
// browser's own wall clock, which is the conversion the Next dialogs did inline.
export function toDateTimeLocal(date: Date): string {
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, 16);
}

// ...and back. The controller stores the instant, exactly as the server action stored the
// `Date` the browser had built.
export function toInstant(value: string): string {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toISOString();
}
